import styled, { keyframes } from 'styled-components';
import {
  Box,
  Paper,
  TextField,
  Button,
  Card,
  Alert,
  Accordion,
  Typography,
  Chip,
  Divider,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Modal,
  Link
} from '@mui/material';
import { MdClose } from 'react-icons/md';

export const textColor = "#333333";
export const primaryColor = "#E30B5D";
export const secondaryColor = '#4B006E';
export const secondaryAltColor = "#E7DFEB";

export const Container = styled(Box)`
  max-width: 100vw;
  max-height: 100vh;
  margin: auto;
  background-color: transparent;
  min-height: 100vh;
  
  @media (max-width: 960px) {
    overflow-x: hidden;
    overflow-y: auto;
  }
  
  @media (max-width: 600px) {
    overflow-x: hidden;
    overflow-y: auto;
    height: auto;
  }
`;

export const ChatBox = styled(Box)`
  display: flex;
  gap: 16px;
  align-items: center;
  margin-top: 16px;
`;

export const ChatSendButton = styled(Button)`
  min-width: 120px;
  height: 56px;
`;

export const Content = styled(Box)`
  min-height: 100vh;
  height: auto;
  overflow: visible;
  
  @media (max-width: 960px) {
    overflow-y: auto;
    overflow-x: hidden;
  }
  
  @media (max-width: 600px) {
    overflow-y: auto;
    overflow-x: hidden;
  }
`;

export const LibbieContainer = styled.div``;

export const BackgroundBlur = styled(Box)`
  backdrop-filter: blur(20px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 700px;
  max-width: 92vw;
  max-height: 80vh;
  overflow: hidden;
  border-radius: 20px;
  z-index: 2;

  @media (max-width: 600px) {
    max-height: none;
    overflow: visible;
    padding-top: 3rem;
    padding-bottom: 1.5rem;
    padding-inline: 0.4rem;
    width: 330px;
    border-radius: 20px !important;
  }

  @media (max-width: 600px) and (max-height: 620px) {
    padding-top: 2rem;
    padding-bottom: 0.75rem;
  }
`;

export const SearchContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  margin: auto;
  height: 100vh;
  /* Reserve space for logo (top ~10%) and disclaimer (bottom ~8%) */
  padding-top: 10%;
  padding-bottom: 8%;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: 960px) {
    height: auto;
    min-height: 100vh;
    padding: 4rem 0 2rem;
    overflow: visible;
  }

  @media (max-width: 600px) {
    height: 100dvh;
    min-height: unset;
    padding: 0.5rem 0.5rem;
    gap: 0.4rem;
    overflow: hidden;
    justify-content: center;
  }
`;

export const SearchPaperInitial = styled(Paper)`
  background-color: rgba(255, 255, 255, 0.8) !important;
  border: 1px solid #EBECF0;
  backdrop-filter: blur(10px);
  margin-top: 1rem;
  margin-bottom: 1rem!important;
  box-shadow: 0px 0px 10px 0px rgba(75, 0, 110, 0.05) !important;
  z-index: 2;
  border-radius: 30px !important;
  width: 620px;
  max-width: 620px;
  min-width: 320px;

  @media (max-width: 600px) {
    width: 95%;
    max-width: 95%;
    min-width: 90%;
    border-radius: 20px !important;
  }
`;

export const SuggestionsPaper = styled(Paper)`
  background-color: rgba(255, 255, 255, 0.8) !important;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.2) 70%, rgba(255, 255, 255, 0.8) 100%) !important;
  backdrop-filter: blur(10px);
  z-index: 2;
  border: 1px solid #EBECF0;
  box-shadow: 0px 0px 10px 0px rgba(75, 0, 110, 0.05) !important;
  border-radius: 20px !important;
  padding: 0rem 0rem 1.2rem 1.2rem;
  max-width: 70%;
  margin: auto;
  min-width: 300px;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  
  @media (max-width: 960px) {
    max-width: 90%;
    min-width: 90%;
  }
  
  @media (max-width: 600px) {
    max-width: 95%;
    min-width: 95%;
    padding: 0rem 0rem 0.8rem 0.8rem;
  }
`;

export const SearchPaper = styled(Paper)`
  background-color: rgba(0, 0, 0, 0.15) !important;
  backdrop-filter: blur(10px);
`;

export const SearchBoxInitial = styled(Box)`
  display: flex;
  justify-content: center;
  padding: 0.3rem;
  align-items: center;
`;

export const SearchBox = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const CustomTextField = styled(TextField)`
  background-color: ${({ feedbackMode }) => feedbackMode ? secondaryColor : "transparent"};
  & .MuiFormLabel-root {
    color: '#000';
    font-size: 12px;
    &.Mui-focused {
      color: #000;
      font-size: 12px;
      border-color: transparent !important;
    }
  }
  & .MuiInputBase-input {
    color: ${({ feedbackMode }) => feedbackMode ? "white" : "black"};
    font-size: 12px;
    font-weight: ${({ feedbackMode }) => feedbackMode ? "bold" : "normal"};
    font-family: RobotoRegular !important;
    border-color: transparent !important;
    
    &::placeholder {
      color: ${({ feedbackMode }) => feedbackMode ? "white" : "grey"};
      opacity: 1;
      font-size: 0.875rem;
    }
    
    @media (max-width: 600px) {
      font-size: 10px;
      visibility: visible !important;
      opacity: 1 !important;
    }
  }
    
  & .MuiOutlinedInput-root {
    & fieldset {
      color: #000;
      border-color: transparent !important;
      font-size: 12px;
    }
    &:hover fieldset {
      color: #000;
      border-color: transparent !important;
      font-size: 12px;
    }
    &.Mui-focused fieldset {
      color: #000;
      border-color: transparent !important;
      font-size: 12px;
    }
    
    @media (max-width: 600px) {
      visibility: visible !important;
      opacity: 1 !important;
      display: flex !important;
    }
  }
  
  @media (max-width: 600px) {
    visibility: visible !important;
    opacity: 1 !important;
    display: block !important;
    width: 100% !important;
  }
`;

export const CustomTextFieldFeedback = styled(TextField)`
  & .MuiFormLabel-root {
    color: #cdcdcd;
    font-size: 12px;
    &.Mui-focused {
      color: #000;
      font-size: 12px;
      border-color: transparent !important;
    }
  }
  & .MuiInputBase-input {
    color: #000;
    font-size: 12px;
    border-color: #cdcdcd !important;
    font-weight: 300;
  }
    
  & .MuiOutlinedInput-root {
    & fieldset {
      color: #000;
      font-size: 12px;
      border-color: #cdcdcd !important;
    }
    &:hover fieldset {
      color: #000;
      font-size: 12px;
      border-color: #cdcdcd !important;
    }
    &.Mui-focused fieldset {
      color: #000;
      font-size: 12px;
      border-color: #cdcdcd !important;
    }
  }
`;

export const SearchEndContainer = styled.div`
  position: fixed;
  z-index: 1100;
  top: 50%;
  left: 2.5%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (max-width: 600px) {
    top: 1rem;
    left: 1rem;
    transform: none;
  }
`;

export const RequestAssistanceContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const SearchButton = styled(Button)`
  color: white !important;
  background-color: ${props => {
    if (props.active) return primaryColor;
    return props.feedbackMode ? secondaryColor : primaryColor;
  }} !important;
  border-radius: 100% !important;
  height: 40px;
  width: 40px;
  min-width: 40px !important;
  padding: 0.5rem !important;
  margin: 0.1rem !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: ${props => props.active ? `2px solid ${primaryColor}` : '2px solid transparent'} !important;
  box-shadow: ${props => props.active ? `0 0 10px ${primaryColor}40` : 'none'} !important;
  transform: ${props => props.active ? 'scale(1.1)' : 'scale(1)'} !important;
  transition: all 0.2s ease !important;
  
  &:hover {
    transform: ${props => props.active ? 'scale(1.15)' : 'scale(1.05)'} !important;
  }
  
  & .MuiCircularProgress-root {
    color: white !important;
    animation: MuiCircularProgress-keyframes-circular-rotate 1.4s linear infinite !important;
  }
  
  @media (max-width: 600px) {
    height: 35px;
    width: 35px;
    min-width: 35px !important;
    padding: 0.4rem !important;
  }
`;

export const SearchButtonSmall = styled(Button)`
  color: white !important;
  background-color: ${props => {
    if (props.active) return primaryColor;
    return props.feedbackMode ? secondaryColor : primaryColor;
  }} !important;
  border-radius: 100% !important;
  height: 30px;
  width: 30px;
  min-width: 30px !important;
  padding: 0.5rem !important;
  margin: 0.1rem !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: ${props => props.active ? `2px solid ${primaryColor}` : '2px solid transparent'} !important;
  box-shadow: ${props => props.active ? `0 0 10px ${primaryColor}40` : 'none'} !important;
  transform: ${props => props.active ? 'scale(1.1)' : 'scale(1)'} !important;
  transition: all 0.2s ease !important;
  
  &:hover {
    transform: ${props => props.active ? 'scale(1.15)' : 'scale(1.05)'} !important;
  }
  
  & .MuiCircularProgress-root {
    color: white !important;
    animation: MuiCircularProgress-keyframes-circular-rotate 1.4s linear infinite !important;
  }
  
  @media (max-width: 600px) {
    height: 35px;
    width: 35px;
    min-width: 35px !important;
    padding: 0.4rem !important;
  }
`;


export const LevelMapButtons = styled(Button)`
  color: ${ primaryColor } !important;
  background-color: transparent !important;
  border-radius: 100% !important;
  height: 30px;
  width: 30px;
  min-width: 30px !important;
  padding: 0.5rem !important;
  margin: 0.1rem !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: ${props => props.active ? `2px solid ${primaryColor}` : '2px solid rgb(239, 239, 239)'} !important;
  box-shadow: ${props => props.active ? `0 0 10px ${primaryColor}40` : 'none'} !important;
  transform: ${props => props.active ? 'scale(1.1)' : 'scale(1)'} !important;
  transition: all 0.2s ease !important;
  
  &:hover {
    background-color: transparent !important;
    border-color: ${props => props.active ? primaryColor : 'white'} !important;
    transform: ${props => props.active ? 'scale(1.15)' : 'scale(1.05)'} !important;
  }
  
  & .MuiCircularProgress-root {
    color: white !important;
    animation: MuiCircularProgress-keyframes-circular-rotate 1.4s linear infinite !important;
  }
  
  @media (max-width: 600px) {
    height: 35px;
    width: 35px;
    min-width: 35px !important;
    padding: 0.4rem !important;
  }
`;

export const SearchSecondaryButton = styled(Button)`
  color: white !important;
  background-color: #f6f6f6 !important;
  border-radius: 100% !important;
  height: 40px;
  width: 40px;
  min-width: 40px !important;
  margin: 0.4rem !important;
`;

export const LevelMapButtonsContainer = styled(Box)`
  display: flex;
  gap: 0.3rem;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 0.5rem;
  flex-wrap: wrap;
`;

export const EndButton = styled(Button)`
  color: white !important;
  background-color: ${primaryColor} !important;
  border-radius: 100% !important;
  height: 50px;
  width: 50px;
  min-width: 50px !important;
  box-shadow: 0px 0px 10px 0px #4B006E0D !important;
  z-index:1000!important;
  @media (max-width: 600px) {
    height: 40px;
    width: 40px;
    min-width: 40px !important;
  }
`;

export const ErrorAlert = styled(Alert)`
  margin-bottom: 24px;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Widget = styled.div`
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translate(-50%, -50%);
  max-width: 60vw;
`;

export const ResultsBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  height: auto;
  padding: 1rem;

  
  @media (max-width: 960px) {
    flex-direction: column;
    padding: 0.5rem;
    overflow-y: visible;
    scrollbar-width: none;  
    max-height: 100vh;
    justify-content: flex-start;
    align-items: center;
  }
`;

export const SimilarAnswers = styled.div`
  opacity: ${(props) => (props.show ? 1 : 0)};
  animation: ${(props) => (props.show ? fadeIn : 'none')} 0.6s ease-out;
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  max-height: 80vh;
  width: 50vw;
  overflow-y: scroll;
`;

export const ShortcutChipContainer = styled('div')({
  display: 'flex',
  gap: '0.5rem',
  marginTop: '1rem',
  flexWrap: 'wrap',
});

export const ResponseCardChatbot = styled(Card)`
  background-color: rgba(255, 255, 255, 0.8) !important;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.2) 70%, rgba(255, 255, 255, 0.4) 100%) !important;
  backdrop-filter: blur(20px);
  border-radius: 20px !important;
  min-height: 40vh;
  max-height: none;
  height: auto;
  box-shadow: 0px 0px 10px 0px #4B006E0D !important;
  border: 1px solid #EBECF0 !important;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  @media (max-width: 600px) {
    margin-top: 4.5rem;
    max-width: 100%;
  }
`;

export const Chatbot = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 50vw;
  margin-right: 2rem;
  margin-top: 6rem;

  @media (max-width: 960px) {
    width: 100%;
    margin-right: 0;
    padding: 0.5rem;
  }

  @media (max-width: 600px) {
    width: 100%;
    max-width: 100vw;
    box-sizing: border-box;
    margin-top: 0;
    margin-left: 0;
    margin-right: 0;
    padding: 0.5rem;
  }
`;

export const ResponseCard = styled(Card)`
  margin-bottom: 24px;
  background-color: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(10px);
  text-align: left;
  height: 70%;
  padding: 1rem;
  border-radius: 10px !important;
`;

export const ChatbotMessageBubble = styled.div`
  background-color:${({ role }) => (role === 'user' ? primaryColor : '#fff')};
  position: relative;
  border-radius: ${({ role }) => (role === 'user' ? '20px 20px 0px 20px' : '20px 20px 20px 0px')};
  padding: 1rem;
  margin-inline: 1rem;
  align-self: ${({ role }) => (role === 'user' ? 'flex-end' : 'flex-start')};
  flex: 0 1 auto;
  min-width: 0;
  max-width: 85%;
  overflow-wrap: break-word;
  word-break: break-word;
  word-wrap: break-word;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  @media (max-width: 960px) {
    max-width: 80%;
    margin-inline: 0.75rem;
  }

  @media (max-width: 600px) {
    max-width: 90%;
    margin-inline: 0.5rem;
    padding: 0.75rem;
    font-size: 0.9rem;
  }
`;

export const ChatbotMessageLibbie = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  max-width: 100%;
  min-width: 0;
  width: 100%;
  flex-wrap: wrap;
  gap: 0.5rem;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const ChatbotMessageBubbleContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  scrollbar-width: none;
  flex-direction: column;
  gap: 2rem;
  overflow-y: auto;
  padding-top: 1rem;
  min-height: 70vh;
  height: auto;
  overflow-x: hidden !important;
  flex: 1;
  max-height:50vh!important;
  
  @media (max-width: 960px) {
    min-height: 50vh;
    height: auto;
    gap: 1.5rem;
    padding-top: 0.5rem;
  }
  
  @media (max-width: 600px) {
    max-height:75vh!important;
    min-height: 40vh;
    height: auto;
    gap: 1rem;
    padding-top: 0.5rem;
  }
`;

export const SimilarAnswersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 40vw;
`;

export const HorizontalScrollContainer = styled(Box)`
  display: flex;
  overflow-x: auto;
  overflow-y: none;
  gap: 16px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const HorizontalSectionTitle = styled(Typography)`
  color: white;
  font-weight: 500 !important;
  font-size: 1rem !important;
  padding-bottom: 0.5rem;
  text-align: center;
`;

export const SuggestionsContainer = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.5rem',
  justifyContent: 'flex-start',
  maxWidth: '100%',
  paddingLeft: '1rem',
  paddingRight: '1rem',
  boxSizing: 'border-box',
});

export const SuggestionsDropdown = styled.div`
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  padding: 0.5rem;
`;

export const SuggestionItem = styled.div`
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-size: 12px;
  color: #333;
`;

export const TextFieldContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-inline: 1rem;
  
  @media (max-width: 600px) {
    margin-inline: 0.5rem;
    gap: 0.25rem;
    visibility: visible !important;
    opacity: 1 !important;
    display: flex !important;
  }
`;

export const SimilarAnswersTitle = styled(Typography)`
  color: white;
  font-weight: 500 !important;
  font-size: 1rem !important;
`;

export const SimilarAnswersContent = styled.div`
  min-height: 40%;
  max-height: 40%;
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const FAQAccordion = styled(Accordion)`
  margin-bottom: 1rem;
  padding: 0.5rem;
  border-radius: 30px !important;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.2) 70%, rgba(255, 255, 255, 0.4) 100%) !important;
  box-shadow: 0px 0px 10px 0px #4B006E0D !important;
  border: 1px solid #EBECF0 !important;
  &.MuiAccordion-root:before {
    display: none !important;
  }
`;

export const StyledAccordionSummary = styled(AccordionSummary)`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const AccordionSummaryBox = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const AccordionQuestion = styled(Typography)`
  flex-grow: 1;
  color: black;
  text-align: left;
  font-weight: 500 !important;
  font-size: 1rem !important;
`;

export const AccordionDetailsBox = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const StyledAccordionDetails = styled(AccordionDetails)`
  display: flex;
  flex-direction: column;
`;

export const AccordionDivider = styled(Divider)`
  margin: 16px 0;
`;

export const ChipsContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-inline: auto;
  margin-bottom: 16px;
  color: black;
`;

export const InstructionsCard = styled(Card)`
  margin-top: 32px;
  background-color: rgba(0, 0, 0, 0.15) !important;
  backdrop-filter: blur(10px);
`;

export const InstructionsText = styled(Typography)`
  color: black;
  padding: 0.5rem;
  font-weight: 500 !important;
  font-size: 1rem !important;
`;

export const InstructionsTextContainer = styled(Typography)`
  display: flex;
  max-width: 50%;
  margin: auto;
  text-align: left;
  gap: 0rem;
  flex-direction: column;
  font-weight: 500 !important;
  font-size: 1rem !important;
`;

export const FAQTable = styled.table`
  border-collapse: collapse;
  width: 100%;
  margin: 16px 0;
`;

export const FAQTableHeader = styled.th`
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
`;

export const FAQTableCell = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
`;

export const FAQLink = styled.a`
  color: #1976d2;
  text-decoration: underline;
`;

export const MatchChip = styled(Chip)`
  margin-left: 16px;
  color: black;
  &.MuiChip-outlined {
    border-color: #ddd;
  }
  &.MuiChip-colorSecondary {
    background-color: transparent;
    color: black;
  }
  &.MuiChip-colorPrimary {
    background-color: #1976d2;
    color: black;
  }
`;

export const CustomChip = styled(Chip)`
  color: white !important;
  &.MuiChip-outlined {
    border-color: #ddd;
  }
  &.MuiChip-colorSecondary {
    color: white !important;
  }
  & .MuiChip-label {
    color: black !important;
  }
`;

export const KeyboardIcon = styled.div`
  border: none;
  border-radius: 50%;
  padding: 8px;
  margin-inline: 2px;
  cursor: pointer;
  
  @media (max-width: 600px) {
    display: none !important;
  }
`;

// ===== NEW ADDITIONS TO REPLACE INLINE STYLES =====

// Logo
export const LogoImage = styled.img`
  position: absolute;
  top: 5%!important;
  z-index: 10;
  left: 50%;
  transform: translate(-50%, -50%);
  height: auto;
  max-width: clamp(80px, 12vw, 160px);
  cursor: pointer;
  margin-top:1rem;

  @media (max-width: 600px) {
    z-index: 10;
    max-width: clamp(70px, 28vw, 120px);
    top: 2%;
  }

  @media (max-width: 600px) and (max-height: 620px) {
    max-width: clamp(55px, 20vw, 90px);
    top: 1.5%;
  }
`;

// Title with gradient
export const GradientTitle = styled(Typography)`
  text-align: center;
  font-size: 26px!important;
  background: linear-gradient(to right, ${secondaryColor}, ${primaryColor}, ${secondaryColor});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: inline-block;
  width: 100vw;
  margin-bottom: 1.5rem!important;
  mask-image: linear-gradient(to right, transparent -100%, black 80%, black 80%, transparent 200%);
  -webkit-mask-image: linear-gradient(to right, transparent -100%, black 80%, black 80%, transparent 200%);

  @media (max-width: 600px) {
    max-width: 90vw;
    font-size: 16px!important;
    margin-bottom: 0.5rem!important;
  }

  @media (max-width: 600px) and (max-height: 620px) {
    font-size: 13px!important;
    margin-bottom: 0.25rem!important;
  }
`;

// Disclaimer at bottom
export const DisclaimerText = styled(Typography)`
  position: absolute;
  max-width: 100%;
  min-width: 280px;
  bottom: 2%;
  left: 50%!important;
  transform: translate(-50%,-50%);
  margin: auto!important;
  text-align: center!important;
  z-index: -1!important;
  color: #777;
  font-family: RobotoRegular;
  font-size: clamp(0.55rem, 0.9vw, 0.85rem)!important;

  @media (max-width: 600px) {
    position: static;
    transform: none;
    left: auto!important;
    bottom: auto;
    z-index: 1!important;
    font-size: clamp(0.65rem, 2.5vw, 0.8rem)!important;
    padding: 0 0.75rem;
    margin-top: 1rem!important;
    max-width: 100%;
  }
`;

// Wayfinding container
export const WayfindingContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  
  @media (max-width: 960px) {
    width: 100%;
    height: auto;
    margin-bottom: 1rem;
  }
  
  @media (max-width: 600px) {
    margin-left: -10px;
    margin-right: 0;
  }
`;


// Level switch buttons container
export const LevelSwitchContainer = styled.div`
  position: absolute;
  top: 5%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  display: flex;
  gap: 0.2rem;
  flex-direction: row;
`;

//Render Left Panel 360 Buttons
export const Three60ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;

export const Three60Container = styled.div`
  margin: auto;
  padding-left: 3.5%;
  box-sizing: border-box;
  width: 100%;
`;

// FAQ Image Container (for image galleries)
export const FAQImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 0rem;
  background-color: rgba(255, 255, 255, 0.1);
  padding: 0.8rem;
  border-radius: 5px;
`;

export const FAQImage = styled.img`
  width: 48%;
  height: auto;
  margin: auto;
  object-fit: cover;
  border-radius: 10px;
`;

// Answer text with pre-wrap
export const AnswerText = styled(Typography)`
  background-color: white;
  border-radius: 30px;
  padding-top: 2rem;
  padding-bottom: 2rem;
  white-space: pre-wrap;
  color: black;
  text-align: justify;
  padding-inline: 2.5rem;
`;

// Chip with margin (for suggestion chips)
export const SuggestionChip = styled(Chip)`
  margin: 0.2rem;
  color: ${secondaryColor};
  border-color: ${secondaryColor};
  height: auto !important;
  & .MuiChip-label {
    white-space: normal;
    word-break: break-word;
    padding-top: 4px;
    padding-bottom: 4px;
  }
  &:hover {
    background-color: ${secondaryColor};
  }
`;

// Chip with margin (for suggestion chips)
export const MapChip = styled(Chip)`
  color: ${primaryColor}!important;
  max-width:20px;
  background-color: transparent!important;
  border: 1px solid ${primaryColor}!important;
  padding:0.5rem 0rem 0.5rem 0rem!important;
`;


// Assistant animation GIF
export const AssistantGif = styled.img`
  width: 100px;
  height: 100px;
  object-fit: contain;
  pointer-events: none;
  margin-right: 1rem;
  z-index: 10;
`;

// Message content wrapper
export const MessageContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  max-width: 100%;
  overflow-x: hidden;
`;


// Top match expanded box
export const TopMatchExpandedBox = styled(Box)`
  max-width:90%!important;
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 12px;
  padding: 1rem;
  @media (max-width: 600px) {
    max-width: 90%!important;
  }
`;

// Read more/Show less button
export const ReadMoreButton = styled(Button)`
  text-transform: none !important;
  justify-content: left !important;
  color: ${primaryColor} !important;
  margin-left: -0.3rem !important;
  width: auto !important;
  font-weight:800!important;
`;

// Top match answer text
export const TopMatchAnswerText = styled(Typography)`
  white-space: pre-wrap !important;
  margin-top:'-1rem';
  color: #333 !important;
  text-align: justify !important;
`;


//=================  Short cut panel styles

export const ShortcutsContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '16px',
  flexWrap: 'wrap',
  marginTop: '0rem',
  borderRadius: '20px!important',
  maxWidth: '660px',
  width: '100%',

  '@media (max-width: 600px)': {
    gap: '5px!important',
    maxWidth: '100%',
  },
  '@media (max-width: 600px) and (max-height: 620px)': {
    gap: '3px!important',
  },
});


export const ShortcutCard = styled('div')(({ theme }) => ({
  cursor: 'pointer',
  backgroundColor: '#fff',
  padding: '1.3rem 1rem 1.3rem 1rem !important',
  marginTop:'0.5rem',
  width: '80px',
  borderRadius: '30px',
  border: '1px solid #EBECF0',
  boxShadow: '0px 0px 10px 0px #4B006E0D',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  
  '@media (max-width: 600px)': {
    width: '58px',
    padding: '0.55rem 0.4rem',
    borderRadius: '20px',
    marginTop: '0.25rem',
  },
  '@media (max-width: 600px) and (max-height: 620px)': {
    width: '48px',
    padding: '0.4rem 0.3rem',
    marginTop: '0.1rem',
  },
}));

// IconButton inside shortcut card
export const ShortcutIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: `${primaryColor}!important`,
  color: `#fff!important`,
  padding: '0.4rem!important',
  marginBottom:'0.5rem!important',
  '@media (max-width: 600px)': {
    padding: '0.25rem!important',
    marginBottom: '0.25rem!important',
  },
  '@media (max-width: 600px) and (max-height: 620px)': {
    padding: '0.15rem!important',
    marginBottom: '0.1rem!important',
  },
}));

export const ShortcutIconButton2 = styled(Button)(({ theme }) => ({
  color: `#fff!important`,
  height:'0px!important',
  marginBottom:'1rem!important'
}));

export const ShortcutIconButton3= styled(Button)(({ theme }) => ({
  height:'0px!important',
  color:`${primaryColor}!important`,
}));

// Typography inside shortcut card
export const ShortcutLabelInternal = styled(Typography)(({ theme }) => ({
  padding: '0.5rem',
  fontFamily: 'RobotoBlack!important',
  textAlign: 'left',
  fontSize:'0.8rem!important',
  color:primaryColor
}));

export const ShortcutLabelInternal2 = styled(Typography)(({ theme }) => ({
  padding: '0.5rem',
  fontFamily: 'RobotoBlack!important',
  textAlign: 'left',
  fontSize:'0.8rem!important',
  color:primaryColor
}));

export const ShortcutLabelInternal3 = styled(Typography)(({ theme }) => ({
  fontFamily: 'RobotoBlack!important',
  textAlign: 'left',
  fontSize:'0.8rem!important',
  color:primaryColor,
  paddingLeft:'0.5rem!important',
}));

export const ShortcutLabel = styled(Typography)(({ theme }) => ({
  marginTop: '1rem',
  fontFamily: 'RobotoMedium!important',
  textAlign: 'center',
  width: '96px',
  fontSize:'0.75rem!important',
  color:primaryColor,
  '@media (max-width: 600px)': {
    marginTop: '0.4rem',
    width: '66px',
    fontSize: '0.62rem!important',
  },
  '@media (max-width: 600px) and (max-height: 620px)': {
    marginTop: '0.2rem',
    width: '56px',
    fontSize: '0.55rem!important',
  },
}));

// Suggestions container
export const SuggestionsContainerShortcut = styled(Paper)(({ theme }) => ({
  padding:'1.3rem 1rem 1.3rem 1rem ',
  maxHeight:'40vh!important',
  overflowY:'auto',
  scrollbarWidth:'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  maxWidth:'40vw!important',
  borderRadius:'20px!important',


  '@media (max-width: 960px)': {
    maxWidth:'85vw!important',
  },
  
}));

// Close button container
export const CloseContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
}));

export const SuggestionItemContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center!important',
  justifyContent: 'center!important',
}));

export const SuggestionsWrapper = styled(Box)({
  textAlign: 'left',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px', // 0.5*8
  padding: '2px', // 0.3*8
  marginTop:'1rem!important',
});

export const LevelContainer = styled(Box)({
  marginTop: '8px', // mt:1 = 8px
});

export const RoomsWrapper = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px', // gap:1 = 8px
});


export const CloseIcon = styled(MdClose)({
  paddingRight: '16px', // 1rem
  cursor: 'pointer',
  marginBottom:'1rem!important',
});

export const RoomChip = styled(Chip)({
  color: secondaryColor,
  borderColor: secondaryColor,
  '&:hover': {
    backgroundColor: secondaryColor,
  },
});



//=================     random gif player styles

export const GifContainer = styled('div')({
  position: 'absolute',
  left: '8%',
  top: '50%',
  transform: 'translateY(-50%)',
  width: '15%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '4px',
  zIndex: 0,

  '@media (max-width: 600px)': {
    display: 'none',
  },
});

export const GifImage = styled('img')({
  width: '100%',
  height: 'auto',
  borderRadius: '1rem',
  objectFit: 'cover',
});


//=================    chatfeedback box styles

export const FeedbackContainer = styled(Box)({
  position: 'relative',
  marginTop: '4px', // 0.5rem
});

export const FeedbackButtonsWrapper = styled(Box)({
  display: 'flex',
  gap: '4px', // 0.5rem
  marginTop: '2px', // 0.25rem
});

export const FeedbackButton = styled(IconButton).withConfig({
  shouldForwardProp: (prop) => prop !== 'feedbackActive',
})(({ feedbackActive }) => ({
  backgroundColor: feedbackActive ? secondaryColor : secondaryAltColor,
  '&:disabled': {
    opacity: 0.6,
  },
}));

export const MessageText = styled(Typography)(({ role }) => ({
  whiteSpace: 'pre-wrap',
  color: role === 'user' ? 'white' : '#333',
  fontSize: '0.85rem!important',
  fontWeight: '800',
  alignSelf: 'stretch',
  fontFamily: 'RobotoMedium!important',
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
  maxWidth: '100%',
  overflowX: 'auto',
}));


//=================    assistant feedback box styles

export const FeedbackBoxWrapper = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
  backgroundColor: '#fff',
  padding: '24px', // 1.5rem
  borderRadius: '20px',
  width: '70%',
  marginLeft:'1rem',
  marginTop:'-1rem',
  
  '@media (max-width: 960px)': {
    width: '80%',
    marginLeft: '0.5rem',
    padding: '16px',
    marginTop:'0.5rem',
    borderRadius: '20px',
  },

});

export const FeedbackTitle = styled(Typography)({
  width: '100%',
  paddingInline: '2px',
  fontFamily: 'RobotoBlack!important',
  fontWeight: 'bold!important',
  color: '#333',
  paddingBottom:'0.5rem'
  
});


export const FeedbackDescription = styled(Typography)({
  paddingInline: '0.5rem',
  color: '#333',
  textTransform:'capitalize'
});


export const FeedbackChip = styled(Chip)({
  color: secondaryColor,
  borderColor: secondaryColor,
  margin:'0.15rem!important',
  border: `1px solid ${secondaryColor} !important`,
  borderRadius:'20px !important',
  boxShadow:`2px 1px 0px 0px rgb(5, 37, 96)`,
  '&:hover': {
    backgroundColor: secondaryColor,
  },
});

export const ZoomButton = styled(Button)(({ active, theme }) => ({
  color: active ? 'white' : secondaryColor,
  backgroundColor: active ? secondaryColor : 'transparent',
  border: `1px solid ${secondaryColor} !important`,
  borderRadius:'20px !important',
  boxShadow:`2px 1px 0px 0px rgb(5, 37, 96)`,
  height:'30px',
}));

//============== SessionFeedback Box styles

export const CenteredModal = styled(Modal)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  '& .MuiBackdrop-root': {
    zIndex: 0,
  },
});

export const FeedbackModalContent = styled(Box)({
  // Explicit stacking: iOS Safari can paint MUI's animated z-index:-1 backdrop over
  // un-positioned modal content, leaving the card hidden behind the grey overlay
  position: 'relative',
  zIndex: 1,
  transform: 'translateZ(0)',
  padding: '30px',
  backgroundColor: '#fff',
  border: '1px solid rgb(242, 242, 242)',
  borderRadius: '20px',
  width: '300px',
  textAlign: 'center',
  boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
  outline: 'none',
});

export const FeedbackIconWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  gap: '16px',
});

export const CommentWrapper = styled(Box)({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#f5f5f5',
  paddingInline: '2px',
  borderRadius: '10px',
});


// ========== Voice button style

export const VoiceButtonContainer = styled('div')({
  border: 'none',
  borderRadius: '50%',
  padding: '8px',
  marginInline: '2px',
  cursor: 'pointer',
});

//======== Zoom call box styles
export const ZoomCallWrapper = styled(Box)({
  marginLeft: '16px',   // ml={2}
  marginTop: '-16px',   // mt={-2}
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',           // gap={1}
  backgroundColor: 'white',
  padding: '24px',      // 1.5rem
  borderRadius: '10px',
  width: '50%',
  
  '@media (max-width: 960px)': {
    width: '80%',
    marginLeft: '0.5rem',
    padding: '16px',
    borderRadius: '20px',
    marginTop: '0.5rem',
  },
  
});


// QR code image
export const ZoomQrImage = styled('img')({
  maxWidth: '180px',
  height: 'auto',
});


export const ZoomContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 0.2rem;
  background-color: rgba(255, 255, 255, 0.8) !important;
  border: 1px solid #EBECF0;
  backdrop-filter: blur(10px);
  box-shadow: 0px 0px 10px 0px rgba(75, 0, 110, 0.05) !important;
  width: 30%;
  border-radius: 50px;
  padding: 2rem;
  margin: auto;
`;

export const ZoomBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap:1rem;
`;

export const ZoomInstructions = styled(Typography)`
  text-align: center;
  font-weight: 500 !important;
  font-size: 12px;
  width:100%;
  margin: auto;

  @media (max-width: 600px) {
    font-size: 13px !important;
  }
`;


//keyboard

export const KeyboardWrapper = styled(Box)({
  width: '100%',
  zIndex: 1000,
  borderRadius: '20px',
  backgroundColor: 'rgba(0,0,0,0.8)',
});

export const StyledTypographyFaqQr = styled(Typography)(({ theme }) => ({
  marginTop: '1rem',
  textAlign: "center",
  backgroundColor: secondaryColor,
  padding: '0.5rem',
  borderRadius: '10px',
}));

// Styled Link
export const StyledLinkFaqQr = styled(Link)(({ theme }) => ({
  fontWeight: 500,
  color: 'white!important',
  textDecoration: "none",
}));

export const ModalTitle = styled(Typography)`
  text-align: center;
  color: ${primaryColor};
  font-size: 1.75rem!important;
  font-weight: 700!important;
  letter-spacing: -0.5px;
  background: linear-gradient(135deg, ${primaryColor} 0%, #7B2CBF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const ModalSubTitle = styled(Typography)`
  margin-bottom: 3rem!important;
  margin-top: 1rem!important;
`;

export const ModalText = styled(Typography)`
  text-align: center;
  color: #555;
  font-size: 0.95rem!important;
  font-weight: 500!important;
  letter-spacing: 0.2px;
`;

export const CategoryShortcutBox = styled(Box)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.25rem;
  width: 100%;
  max-width: 400px;
`;

export const CategoryShortcutContainer = styled(Box)`
  padding-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const CategoryShortcutCard = styled('div')(({ theme }) => ({
  cursor: 'pointer',
  backgroundColor: '#fff',
  padding: '1.5rem!important',
  borderRadius: '24px',
  border: '2px solid #F5F5F7',
  boxShadow: '0px 4px 16px rgba(75, 0, 110, 0.08)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '140px',
  height: '140px',
  justifyContent: 'center',
  position: 'relative',
  
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: '24px',
    padding: '2px',
    background: 'linear-gradient(135deg, rgba(75, 0, 110, 0.1) 0%, rgba(123, 44, 191, 0.1) 100%)',
    WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    WebkitMaskComposite: 'xor',
    maskComposite: 'exclude',
    opacity: 0,
    transition: 'opacity 0.3s ease',
  },
  
  '&:hover::before': {
    opacity: 1,
  },
}));